import { fetchApi } from "../../utils";

const createPhotoquotesApi = data => {
  return fetchApi("photoquotes", "POST", JSON.stringify(data));
};

export { createPhotoquotesApi };



// WEBPACK FOOTER //
// ./src/services/quote/photoquotes.js